import React from 'react';
import './Fun.css';
import funCards from './funConfig';

export default class Fun extends React.Component {
  state = {
    currentFunCardId: 0
  }

  handleChange = () => {
    const { currentFunCardId } = this.state;
    if(currentFunCardId < funCards.length - 1) {
      this.setState({currentFunCardId: currentFunCardId + 1});
    }else {
      this.setState({currentFunCardId: 0});
    }
  }

  render() {
    return (
      <div className="fun">
        <div className="toggle"></div>
        <div className="change" onClick={this.handleChange}>change</div>
        <div className="fun-container">
          {
            funCards[this.state.currentFunCardId].fun
          }
        </div>  
      </div>
    )
  }
}